import React, { useEffect, useState } from 'react';

import * as NUMBER from '../../../../common/constants/number';
import * as SIZE from '../../../../common/constants/live/size';

export default function TranslateList(props) {
  const innerId = 'module-translate-inner';
  const boxId = 'module-translate-box';
  const buttonId = 'module-translate-scroll-down';

  const [end, setEnd] = useState(true);

  const handleClickGoListDown = () => {
    setEnd(true);
  };

  const handleScroll = (event) => {
    const container = event.currentTarget;
    if (
      container.scrollTop + container.offsetHeight >
      container.scrollHeight - SIZE.LIVE_TRANSLATE_SCROLL_MARGIN_END
    ) {
      setEnd(true);
    } else {
      setEnd(false);
    }
  };

  // 스크롤 버튼클릭시 포커스 이동
  useEffect(() => {
    setTimeout(() => {
      const focusEle = document.getElementById(buttonId);
      focusEle.focus();
    }, NUMBER.DELAY_MOVE_FOCUS);
  }, [props.language]);

  useEffect(() => {
    if (end) {
      document.getElementById(innerId).scrollTop =
        document.getElementById(boxId).offsetHeight;

      // 웹 접근성 포커스 자동이동
      const focusEle = document.activeElement;
      if (
        focusEle.parentElement.id === boxId ||
        focusEle.parentElement.id === innerId
      ) {
        setTimeout(() => {
          const lastInputText = document.querySelector(`#${boxId}`).lastChild;
          if (lastInputText) lastInputText.focus();
        }, NUMBER.DELAY_MOVE_FOCUS);
      }
    }
  }, [props.data, end]);

  return (
    <div
      id={innerId}
      className={`module_translate_inner ${props.language}`}
      onScroll={handleScroll.bind(this)}
    >
      <button
        id={buttonId}
        type="button"
        className={`btn_golist_down ${end ? '' : 'current'}`}
        onClick={handleClickGoListDown.bind(this)}
      >
        <span className="icon_down_arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9.846"
            height="16"
            viewBox="0 0 9.846 16"
          >
            <path
              d="M20.9,13.678a.634.634,0,0,1-.944.006l-3.123-3.373V23.165a.668.668,0,1,1-1.333,0V10.311L12.383,13.69a.638.638,0,0,1-.944-.006.763.763,0,0,1,.005-1.017L15.7,8.088h0a.747.747,0,0,1,.21-.15.594.594,0,0,1,.256-.056.642.642,0,0,1,.467.206l4.256,4.579A.75.75,0,0,1,20.9,13.678Z"
              transform="translate(21.094 23.882) rotate(180)"
            />
          </svg>
          <i className="hide">내용 아래로 내리기</i>
        </span>
      </button>
      <div id={boxId} className="module_translate_box">
        {props.data.map(function (item, index) {
          return (
            <>
              <p
                tabIndex={index === props.data.length - 1 ? '0' : '0'}
                style={{ fontSize: `${props.size}px` }}
                className="module_translate_text"
              >
                {item[props.language].StringValue}
              </p>
            </>
          );
        })}
      </div>
    </div>
  );
}
